import React from "react";
import Header from "./Header";
import Footer from "./Footer";
import "../css/returns.scss";

function Returns() {
  return (
    <div className="returns">
      <Header />
      <main><div className="inner-pg">
        <div className="content"><h1>Returns and Repairs</h1></div>
        <div className="content">
          <strong>RETURN REQUESTS</strong>
          <p>Eligible unworn items may be requested for return within 14 days of delivery. Email <u>print@shiskerstone.xyz</u> with your order number and the item you wish to return before sending anything back.</p>
          <strong>CONDITION</strong>
          <p>Items must be unused, unaltered, and returned with all protective materials and original presentation packaging. Returns that show wear, damage, missing components, or improper packing may be declined.</p>
          <strong>EXCLUSIONS</strong>
          <p>Personalized, altered, made-to-order, hygiene-sensitive, and clearly marked final-sale items are not eligible unless faulty or otherwise required by applicable consumer law.</p>
          <strong>RETURN SHIPPING AND REFUNDS</strong>
          <p>Return instructions and any applicable shipping cost will be confirmed when the request is approved. Original delivery charges and import costs are not refundable unless required by law. Approved refunds are issued to the original payment method after inspection; bank processing times vary.</p>
          <strong>DAMAGED OR INCORRECT ITEMS</strong>
          <p>If an order arrives damaged, defective, or incorrect, email us within 48 hours of delivery with the order number, a description, and clear photographs of the item and packaging. Keep all packaging while the issue is reviewed.</p>
          <strong>REPAIRS</strong>
          <p>Repair options depend on the design, materials, condition, and component availability. Send photographs and proof of purchase to <u>print@shiskerstone.xyz</u> for an assessment. Fees and timing will be confirmed before work begins.</p>
          <strong>THIRD-PARTY PURCHASES</strong>
          <p>Items purchased from another retailer must be returned to that retailer under its own policy.</p>
        </div>
      </div></main>
      <Footer />
    </div>
  );
}

export default Returns;
